import { useCurrentLocale, useLocaleList } from '@/composables/locale'
import { useRoute } from '@/composables/route'
import { defineComponent } from 'vue'

// Switch the locale with a single full-page POST instead of an Inertia POST followed by a
// separate location.reload(). The Inertia variant issued two session-touching GETs (the 302
// follow + the reload) that raced and clobbered the guest session locale. A native form submit
// gives the working sequential pattern — POST → 302 → one full GET — which also reloads the
// Blade shell so window._translations / window._locales pick up the new locale.
const submitLocaleSwitch = (locale) => {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = useRoute('locales.switch', { locale })

  const token = document.querySelector('meta[name="csrf-token"]')?.content
  if (token) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = '_token'
    input.value = token
    form.appendChild(input)
  }

  document.body.appendChild(form)
  form.submit()
}

export default defineComponent({
  setup(props, { slots }) {
    return () =>
      slots.default({
        current: useCurrentLocale(),
        list: useLocaleList(),
        change: (locale) => submitLocaleSwitch(locale),
      })
  },
})
